module.exports = __webpack_public_path__ + "img/yxy.ffe96587.jpg";